
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


const Sattachart = () => {
  const [marketData, setMarketData] = useState([]);
  console.warn(marketData)
  const navigate = useNavigate();

  useEffect(() => {
    fetchMarketData();
  }, []);

  const fetchMarketData = async () => {
    try {
      const response = await fetch("https://a-71ajsatta.com/Admin/public/api/getAllMarketData", {
        method: "POST",
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.warn(data)
      console.log(data); // Log the response for debugging
      if (data.data && data.data.allMarketData) {
        setMarketData(data.data.allMarketData);
      }
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };
  const convertTo24HourFormat = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  };

  const handleClick2 = async (market_id, year) => {
    // alert(market_id,year)

    navigate('/Markets');

    localStorage.setItem('marketchart_id', market_id,);
    localStorage.setItem('yearrr', year,);

  };

  return (
    <section className="tablebox1" id="sattachart">
      <div class="octoberresultchart">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <h1 className="text-white">SATTA CHART</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="nopadding">

        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="forblack">
              {/* <tr>
                <th className="col-md-4 text-center">सट्टा का नाम</th>
                <th className="col-md-4 text-center">कल आया था</th>
                <th className="col-md-4 text-center">आज का रिज़ल्ट</th>
              </tr> */}
            </thead>
            <tbody>
              {marketData.map((market, index) => (
                <tr key={index}>
                  <td className="table_chart_section2 col-md-2">
                    {market.market_name}
                    <br />
                  </td>
                  {[ "2022", "2023", "2024", "2025", "2026"].map((year) => (
                    <td className="table_chart_section text-start">
                      <Link
                        key={year}
                        to="/Markets"
                        className="yearbtn "
                        onClick={() => {
                          handleClick2(market.market_id, year);
                        }}
                      >
                        {year}
                      </Link>
                    </td>
                  ))}
                </tr>
              ))}

            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Sattachart;
